import 'regenerator-runtime/runtime';
import { call, put } from 'redux-saga/effects';

import { handleGenericError } from '../common';
import { makeRequest } from './horizon';
import { actions } from '../../reducers/iot/iot';

export default function* controlFan(action) {
  const { device, controlData } = action.payload;

  try {
    yield call(
      makeRequest,
      device.id,
      'printer/fan',
      {
        method: 'post',
        query: controlData,
      },
      'controlFan'
    );
    yield put(actions.controlFanSuccess());
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
